import { render, staticRenderFns } from "./labelUpload.vue?vue&type=template&id=3f48393a&scoped=true"
import script from "./labelUpload.vue?vue&type=script&lang=js"
export * from "./labelUpload.vue?vue&type=script&lang=js"
import style0 from "./labelUpload.vue?vue&type=style&index=0&id=3f48393a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48393a",
  null
  
)

export default component.exports